import { Link } from "react-router-dom";
import { categories, siteMeta } from "@/mocks/meta";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="wrap py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand */}
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5" aria-label="吃瓜精选 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-vip-crown-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="serif text-lg font-black text-background-50">吃瓜精选</span>
                <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.28em] text-background-400">Chigua Picks</span>
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">{siteMeta.tagline}</p>
            <div className="mt-6 flex items-center gap-3">
              {["weibo", "douban", "bilibili"].map((s) => (
                <a
                  key={s}
                  href="#"
                  rel="nofollow"
                  onClick={(e) => e.preventDefault()}
                  aria-label={s}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-600/60 text-background-300 transition-colors hover:border-primary-400 hover:text-primary-300"
                >
                  <i className={`${s === "weibo" ? "fa-brands fa-weibo" : s === "douban" ? "fa-solid fa-dove" : "ri-tv-2-line"} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* category links */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-background-400">栏目盘点</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-background-200 transition-colors hover:text-primary-300">
                    {c.name} <span className="text-background-500">· {c.nameEn}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* site links */}
          <div className="md:col-span-2">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-background-400">站点</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { to: "/", t: "首页" },
                { to: "/#collections", t: "年度专题" },
                { to: "/about", t: "关于我们" },
                { to: "/faq", t: "常见问题" },
              ].map((l) => (
                <li key={l.t}>
                  <Link to={l.to} className="text-sm text-background-200 transition-colors hover:text-primary-300">
                    {l.t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div className="md:col-span-2">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-background-400">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <a href={`mailto:${siteMeta.contactEmail}`} className="break-all transition-colors hover:text-primary-300">
                  {siteMeta.contactEmail}
                </a>
              </li>
              <li className="text-background-400">投稿 / 提供线索欢迎来信</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">© {year} {siteMeta.name} · 娱乐内容整理与盘点平台，仅提供娱乐资讯整合。</p>
          <p className="text-xs text-background-500">按主题汇总、系列整理，点开即得系统化内容。</p>
        </div>
      </div>
    </footer>
  );
}